import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectors as authSelectors, actions as authActions } from 'state/auth';

const useAddPermission = () => {
  const user = useSelector(authSelectors.getUser);
  const permissions = useMemo(() => user.user_permissions, [user]);
  const dispatch = useDispatch();

  const addPermission = useCallback(
    (newPermission) => {
      const newPermissions = new Set([...permissions, newPermission]);
      const userWithNewPermissions = {
        ...user,
        user_permissions: [...newPermissions],
      };
      dispatch(authActions.setUser(userWithNewPermissions));
    },
    [dispatch, user, permissions]
  );

  return addPermission;
};

export default useAddPermission;
